// extracted by mini-css-extract-plugin
export default {"productGrid":"RY-z","centerLink":"SY-z","productSection":"TY-z","item":"UY-z","ctaButton":"VY-z"};